import { Card, CardContent } from "@shared/components/ui/card";
import { Badge } from "@shared/components/ui/badge";
import { CalendarCheck2, MapPinIcon, Check, Package } from "lucide-react";
import { STATUS_OPTIONS, STATUS_COLORS } from "@shared/utils/constants";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { cn } from "@/lib/utils";

export function PackageSelectCard({ pkg, isSelected, onSelect }) {
  const { customer, status, totalAmount, createdAt, trackingNumber } = pkg;
  const { t } = useTranslation();

  return (
    <Card
      className={cn(
        "relative cursor-pointer transition-all duration-200 hover:shadow-md border-2",
        isSelected
          ? "border-primary shadow-sm bg-primary/5"
          : "border-border hover:border-primary/50"
      )}
      onClick={() => onSelect(pkg)}
    >
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          {/* Package Info */}
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <div
                className={cn(
                  "p-2 rounded-full",
                  isSelected ? "bg-primary text-primary-foreground" : "bg-muted"
                )}
              >
                <Package className="h-4 w-4" />
              </div>
              <div>
                <p className="font-semibold text-sm">
                  {trackingNumber || t("packages.noTracking")}
                </p>
                <p className="text-muted-foreground text-xs">
                  {customer.phone} | {customer.name}
                </p>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Badge
                  variant="secondary"
                  className={cn(
                    "text-xs",
                    STATUS_COLORS[status] || "bg-gray-100"
                  )}
                >
                  {t(STATUS_OPTIONS[status] || status)}
                </Badge>

                <div className="flex items-center text-muted-foreground text-xs">
                  <CalendarCheck2 className="h-3 w-3 mr-1" />
                  {format(new Date(createdAt), "dd/MM/yyyy")}
                </div>
              </div>

              <div className="text-right">
                <p className="font-semibold text-sm">
                  {totalAmount.toFixed(2)} {t("main.currency")}
                </p>
                <div className="flex items-center text-muted-foreground text-xs">
                  <MapPinIcon className="h-3 w-3 mr-1" />
                  <span className="truncate max-w-20">
                    {customer.city || t("main.unknown")}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Selection Indicator */}
          {isSelected && (
            <div className="absolute top-2 right-2 bg-primary text-primary-foreground rounded-full p-1 z-10">
              <Check className="h-3 w-3" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
